export default __webpack_public_path__ + "static/media/news (2).fb0c5509.webp";